import Vue from 'vue'
import VueI18n from 'vue-i18n'
import storage from 'store'
import moment from 'moment'

// default lang
import zhCn from './lang/zh-CN'

Vue.use(VueI18n)

export const defaultLang = 'zh-CN'

const messages = {
  'zh-CN': {
    ...zhCn
  }
}

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

const loadedLanguages = [defaultLang]

function setI18nLanguage (lang) {
  i18n.locale = lang
  // request.headers['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang = defaultLang) {
  return new Promise(resolve => {
    // 缓存语言设置
    storage.set('lang', lang)
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
          const locale = msg.default
          i18n.setLocaleMessage(lang, locale)
          loadedLanguages.push(lang)
          moment.updateLocale(locale.momentName, locale.momentLocale)
          return setI18nLanguage(lang)
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}

export function i18nRender (key) {
  if (key === undefined || key === null || key === '') {
    return ''
  }
  if (i18n.te(key)) {
    return i18n.t(key)
  }
  const routeKey = `menu.route.${key}`
  if (i18n.te(routeKey)) {
    return i18n.t(routeKey)
  }
  const nameKey = `menu.names.${key}`
  if (i18n.te(nameKey)) {
    return i18n.t(nameKey)
  }
  return key
}

export function getSiteTitle () {
  return i18nRender('app.siteTitle')
}

export function renderMenuTitle (meta) {
  if (!meta) {
    return ''
  }
  if (meta.customTitle) {
    return i18nRender(meta.customTitle)
  }
  if (i18n.locale === 'en-US' && meta.titleEn) {
    return meta.titleEn
  }
  const candidates = [meta.titleKey, meta.title].filter(Boolean)
  for (const key of candidates) {
    const translated = i18nRender(key)
    if (translated !== key || i18n.te(key)) {
      return translated
    }
  }
  return meta.title || meta.titleKey || ''
}

export function localizeMenuTree (nodes, field = 'label') {
  if (!Array.isArray(nodes) || nodes.length === 0) {
    return []
  }
  return nodes.map(node => ({
    ...node,
    [field]: i18nRender(node[field]),
    children: localizeMenuTree(node.children, field)
  }))
}

export default i18n
